import React, { useState, useEffect } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import toast from 'react-hot-toast'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import Cookies from 'js-cookie'
import axios from 'axios'
import { useAuth } from './AuthContext'

const EditEnquiryForm = ({ show, handleClose, enquiry, fetchEnquiries }) => {
  const { user } = useAuth()
  console.log('USER IS :', user)
  const [updatedEnquiry, setUpdatedEnquiry] = useState({
    name: '',
    email: '',
    phone: '',
    course_id: '',
    message: '',
    dob: '',
    gender: '',
    address: '',
    mother_name: '',
    father_name: '',
    parents_number: '',
    status: '',
  })
  const [courses, setCourses] = useState([])
  const [token, setToken] = useState(null)
  useEffect(() => {
    ApiEndpoints.getAllCourses().then((res) => setCourses(res.data.data))
  }, [])

  useEffect(() => {
    if (enquiry) {
      setUpdatedEnquiry({
        name: enquiry.name || '',
        email: enquiry.email || '',
        phone: enquiry.phone || '',
        course_id: enquiry.course_id || '',
        message: enquiry.message || '',
        dob: enquiry.dob || '',
        status: enquiry.status || '',
        gender: enquiry.gender || '',
        address: enquiry.address || '',
        mother_name: enquiry.mother_name || '',
        father_name: enquiry.father_name || '',
        parents_number: enquiry.parents_number || '',
      })
    }
  }, [enquiry])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setUpdatedEnquiry((prev) => ({ ...prev, [name]: value }))
  }

  const handleSaveChanges = async () => {
    try {
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user?.token}`,
        // institute_id: Number(institueId),
      }

      console.log('HEADERS ARE: ', headers)
      const response = await axios.put(
        BASE_URL+`/enquiry/${enquiry.id}`,
        updatedEnquiry,
        { headers },
      )
      toast.success(response.data.message)
      handleClose()
      fetchEnquiries()
    } catch (error) {
      toast.error(error.response?.data?.message)
    }
  }

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton className="bg-warning text-dark">
        <Modal.Title>Edit Enquiry</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={updatedEnquiry.name}
              onChange={handleInputChange}
              placeholder="Enter name"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Date of Birth</Form.Label>
            <Form.Control
              type="date"
              name="dob"
              value={updatedEnquiry.dob}
              onChange={handleInputChange}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Gender</Form.Label>

            <div>
              <Form.Check
                inline
                type="radio"
                name="gender"
                label="Male"
                value="Male"
                checked={updatedEnquiry.gender === 'Male'}
                onChange={handleInputChange}
              />
              <Form.Check
                inline
                type="radio"
                name="gender"
                label="Female"
                value="Female"
                checked={updatedEnquiry.gender === 'Female'}
                onChange={handleInputChange}
              />
              <Form.Check
                inline
                type="radio"
                name="gender"
                label="Other"
                value="Other"
                checked={updatedEnquiry.gender === 'Other'}
                onChange={handleInputChange}
              />
            </div>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Father's Name</Form.Label>
            <Form.Control
              type="text"
              name="father_name"
              value={updatedEnquiry.father_name}
              onChange={handleInputChange}
              placeholder="Enter father's name"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Mother's Name</Form.Label>
            <Form.Control
              type="text"
              name="mother_name"
              value={updatedEnquiry.mother_name}
              onChange={handleInputChange}
              placeholder="Enter mother's name"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Course</Form.Label>
            <Form.Select
              name="course_id"
              value={updatedEnquiry.course_id}
              onChange={handleInputChange}
            >
              <option value="">Select Course</option>
              {courses.map((course) => (
                <option key={course.id} value={course.id}>
                  {course.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Phone Number</Form.Label>
            <Form.Control
              type="tel"
              name="phone"
              value={updatedEnquiry.phone}
              onChange={handleInputChange}
              placeholder="Enter phone number"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={updatedEnquiry.email}
              onChange={handleInputChange}
              placeholder="Enter email"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Address</Form.Label>
            <Form.Control
              as="textarea"
              name="address"
              value={updatedEnquiry.address}
              onChange={handleInputChange}
              placeholder="Enter address"
              rows={3}
            />
          </Form.Group>
          {/* Description */}
          <Form.Group className="mb-3">
            <Form.Label>Parent's Number</Form.Label>
            <Form.Control
              type="tel"
              name="parents_number"
              value={updatedEnquiry.parents_number}
              onChange={handleInputChange}
              placeholder="Enter parent's phone number"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Message</Form.Label>
            <Form.Control
              as="textarea"
              name="message"
              value={updatedEnquiry.message}
              onChange={handleInputChange}
              placeholder="Drop your message"
              rows={3}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="warning" onClick={handleSaveChanges}>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default EditEnquiryForm
